import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  recaptchaBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    opacity: 0.7,
    fontSize: '0.75rem'
  },
  recaptchaLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    marginLeft: theme.spacing(0.5),
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

/**
 * RecaptchaBadge component
 * Displays a badge informing users that the form is protected by Google reCAPTCHA v3
 * This is a recommended best practice for reCAPTCHA v3 implementation
 */
const RecaptchaBadge = () => {
  const classes = useStyles();

  return (
    <div className={classes.recaptchaBadge}>
      <Typography variant="caption" color="textSecondary">
        This site is protected by reCAPTCHA and the Google{' '}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.recaptchaLink}>
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.recaptchaLink}>
          Terms of Service
        </a>{' '}
        apply.
      </Typography>
    </div>
  );
};

export default RecaptchaBadge;
